import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import classNames from 'classnames';

export interface IProps {
  auth: any;
  signOut: () => void;
  classes: any;
}

const styles = {
  flex:{
    display: 'flex', 
    paddingRight: 20
  },
  colorWhite:{
    color: 'white'
  },
  selfAlignCenter: {
    alignSelf: 'center'
  },
  img: {
    paddingRight: 10
  }
}

class ProfileLink extends React.Component<IProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    }
  }

  handleClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose() {
    this.setState({ anchorEl: null });
  };

  render() {
    const { auth, signOut, classes } = this.props; 
    const { anchorEl } = this.state;
    return(
      <div className="navbar-item">
        <img className={classes.img} style={{maxHeight: 45}} src="/assets/images/profile.png" alt="user image" />
        <div className={classes.flex}>
        <div style={{paddingRight: 10}}>
          <Typography variant="body2" className={classes.colorWhite}>{auth.displayName}</Typography>
          {auth.isAdmin && <Typography variant="body1" className={classes.colorWhite}>ADMIN</Typography>}
        </div>
        <KeyboardArrowDown 
          className={classNames(classes.colorWhite, classes.selfAlignCenter)}
          onClick={this.handleClick.bind(this)}
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true" 
        />
        <div>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose.bind(this)}
        >
          <MenuItem onClick={this.handleClose.bind(this)}>
            <Link to="/profile">
              <div style={{display: 'flex', alignItems: "center"}}>
                <img src="/assets/images/user-icon.png"alt="user profile" style={{paddingRight: 10, height: 30}} />
                <Typography variant="body2">MY PROFILE</Typography>
              </div>
            </Link>
          </MenuItem>
          <MenuItem onClick={signOut}>
            <div style={{display: 'flex', alignItems: "center"}}>
              <img src="/assets/images/logout-hover.png" alt="user profile" style={{paddingRight: 10, height:30}} />
              <Typography variant="body2">LOGOUT</Typography>
            </div>
          </MenuItem>
        </Menu>
        </div>
        </div>
      </div>
    )
  }
}
export default withStyles(styles)(ProfileLink);